// extracted by mini-css-extract-plugin
module.exports = {"goods":"Order_goods__1HHtf","total":"Order_total__YWk8T","header":"Order_header__2Cp30"};